import { Sanity$Video } from '@otovo/shared/types/sanityTypes';
import { PortableTextReactComponents } from '@portabletext/react';
import UnorderedListItem from '../SanityLandingPage/components/UnorderedListItem';
import BreakRenderer from './BreakRenderer';
import SanityLink from './SanityLink';
import YouTubeVideo from './YouTubeVideo';

const PortableTextComponents: PortableTextReactComponents = {
  hardBreak: () => <br />,
  unknownMark: ({ children }) => <span>{children}</span>,
  unknownBlockStyle: ({ children }) => <div>{children}</div>,
  unknownListItem: ({ children }) => <li>{children}</li>,
  unknownList: ({ children }) => <ul>{children}</ul>,
  unknownType: ({ children }) => <div>{children}</div>,
  marks: {
    strong: ({ children }) => (
      <strong className="font-semibold">{children}</strong>
    ),
    link: ({ children, value }) => (
      <SanityLink mark={value}> {children}</SanityLink>
    ),
    callToActionButton: ({ children, value }) => (
      <a
        href={value.link?.href}
        rel={value.link?.rel}
        className="mt-6 inline-block rounded-md bg-peach-60 px-6 py-3 text-white hover:bg-peach-70"
      >
        {children}
      </a>
    ),
  },
  block: {
    h1: ({ children }) => (
      <h2 className="mb-6 text-2xl font-semibold text-balance break-words text-heading md:text-3xl lg:mr-16 lg:text-4xl">
        {children}
      </h2>
    ),
    h2: ({ children }) => (
      <h2 className="mb-6 text-2xl font-semibold text-balance break-words text-heading md:text-3xl lg:mr-16 lg:text-4xl">
        {children}
      </h2>
    ),
    h3: ({ children }) => (
      <h3 className="mb-3 text-2xl font-medium break-words text-heading md:mb-6">
        {children}
      </h3>
    ),
    h4: ({ children }) => (
      <h4 className="mb-3 text-xl font-medium break-words text-heading md:mb-6">
        {children}
      </h4>
    ),
    h5: ({ children }) => (
      <h5 className="mb-3 text-lg font-medium break-words text-heading md:mb-6">
        {children}
      </h5>
    ),
    blockquote: ({ children }) => (
      <blockquote className="text-lg text-body italic">{children}</blockquote>
    ),
    normal: ({ children }) => <p className="text-base text-body">{children}</p>,
  },
  list: {
    bullet: ({ children }) => (
      <ul className="my-4 space-y-2 text-body">{children}</ul>
    ),
    number: ({ children }) => (
      <ol className="my-4 list-decimal space-y-2 pl-4 text-body">{children}</ol>
    ),
  },
  listItem: {
    bullet: ({ children }) => <UnorderedListItem>{children}</UnorderedListItem>,
    number: ({ children }) => <li className="pl-2 text-balance">{children}</li>,
  },
  types: {
    video: ({ value: sanityVideo }: { value: Sanity$Video }) => (
      <YouTubeVideo sanityVideo={sanityVideo} />
    ),
    image: () => null,
    typeformWidget: () => null,
    contentBreak: ({ value }) => <BreakRenderer node={value} />,
  },
};

export default PortableTextComponents;
